/** Dueli: отступы чуть крупнее */
export const primitiveSpacing = {
	1: '1.2rem',
	2: '2.4rem',
	3: '3.6rem',
	4: '4.8rem',
	6: '7rem',
	8: '9rem',
} as const;

export const padding = {
	xLarge: primitiveSpacing[8],
	large: primitiveSpacing[6],
	normal: primitiveSpacing[3],
	small: primitiveSpacing[2],
	xSmall: primitiveSpacing[1],
} as const;
